import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouterProps } from '../../../utils/with-router-props'

import SHSForm from '../../../utils/shs-form'
import InputElement from '../../../utils/input'
import SearchComplete from '../../../utils/search-complete'
import { callApi, fetchApiDataIfNeeded } from '../../../../actions/api'
import { apiResourceEndpoint, buildRoutePath, routes } from '../../../../constants/routes'
import AccountSidebar from '../../../shared/account-sidebar'
import { upsertForm } from '../../../../reducers/form'
import { formStates } from '../../../../constants/helper-states'

const mapStateToProps = (state, ownProps) => {
    const account = state.adminAccounts.find(acc => acc.id === Number(ownProps.params.accountId))
    const imeis = state.adminAccountImeis.filter(i => i.accountId === Number(ownProps.params.accountId))
    return {
        account,
        imeis
    }
}

const AdminImeiCreate = ({ dispatch, navigate, params, imeis, account }) => {
    const accountId = params.accountId

    useEffect(() => {
        if (accountId) {
            dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/accounts', 'VIEW', accountId)))
            dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/account-imeis', 'LIST', null), { filter: [`account_id|${accountId}`] }))
        }
    }, [dispatch, accountId])

    const isDuplicateImei = (imei) => {
        if (imeis.find(i => i.imei === imei)) {
            window.alert('This IMEI already exists for this account. Please enter a unique IMEI.')
            return true
        }
        return false
    }

    // catalog pick assigns immediately — same pattern as the group search in questions/edit.js
    const handleCatalogAssign = (unit) => {
        if (isDuplicateImei(unit.imei)) {
            return
        }
        dispatch(callApi(apiResourceEndpoint('admin/account-imeis', 'CREATE'), {
            accountId,
            imei: unit.imei
        }, -1))
            .then((response) => {
                if (response === 'SUCCESS') {
                    navigate(buildRoutePath(routes.adminImeiIndex.path, { accountId }))
                } else {
                    window.alert('Unable to assign this unit. Please try again.')
                }
            })
    }

    const submitFX = (formData, formId) => {
        if (isDuplicateImei(formData.imei)) {
            // Reset form status so the form becomes available again
            dispatch(upsertForm({ id: formId, status: formStates.EMPTY }))
            return
        }
        formData.accountId = accountId
        dispatch(callApi(apiResourceEndpoint('admin/account-imeis', 'CREATE'), formData, formId))
    }

    const successFX = () => {
        navigate(buildRoutePath(routes.adminImeiIndex.path, { accountId }))
    }

    return (
        <div className="admin-dashboard">
            <div className="header">
                <div className="container">
                    <div className="header-details">
                        <h2>Use the form below to add a new Telematics Unit to the account.</h2>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="sidebar-layout">
                    <div className="sidebar box">
                        <AccountSidebar account={account} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                        <div className="main-content box">
                            <h3>Assign a Ready-to-Install Unit</h3>
                            <div className="search-complete">
                                <SearchComplete
                                    searchEndpoint="admin/telematics-units"
                                    renderTemplate={(unit) => unit.uniqueId ? `${unit.imei} (${unit.uniqueId})` : unit.imei}
                                    onHandleSelect={handleCatalogAssign}
                                    allowCreation={false}
                                    placeholder="Search test bench IMEIs" />
                            </div>
                        </div>
                        <div className="main-content box" style={{ marginTop: '2rem' }}>
                            <SHSForm extraClass="flex-form" submitFX={submitFX} successFX={successFX} resetForm={true}>
                                <InputElement
                                    type="text"
                                    id="imei"
                                    label="Manually Input a Telematics Unit IMEI"
                                    placeholder="346589755412365"
                                    extraClass="flex-33"
                                    required />
                            </SHSForm>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouterProps(connect(mapStateToProps)(AdminImeiCreate))
